module.exports = __webpack_public_path__ + "img/cointelegraph.f5aca135.webp";